import React from "react";
import { Box, Tab, Tabs } from "@mui/material";

export type ProposalEditTab = "validity" | "values" | "address" | "guaranteeData" | "locator" | "cancel";

export interface ProposalEditTabItem {
	key: ProposalEditTab;
	label: string;
}

interface ProposalEditTabsProps {
	value: ProposalEditTab;
	tabs: ProposalEditTabItem[];
	onChange: (tab: ProposalEditTab) => void;
}

export const ProposalEditTabs: React.FC<ProposalEditTabsProps> = ({ value, tabs, onChange }) => {
	return (
		<Tabs
			value={value}
			onChange={(_, newValue) => onChange(newValue)}
			variant="scrollable"
			scrollButtons="auto"
			sx={{
				borderBottom: "none",
				"& .MuiTabs-scroller": { overflowY: "hidden" },
			}}
		>
			{tabs.map((tab) => (
				<Tab key={tab.key} value={tab.key} label={tab.label} />
			))}
		</Tabs>
	);
};

interface ProposalEditTabPanelProps {
	value: ProposalEditTab;
	tab: ProposalEditTab;
	children?: React.ReactNode;
}

export const ProposalEditTabPanel: React.FC<ProposalEditTabPanelProps> = ({ value, tab, children }) => {
	return (
		<div role="tabpanel" hidden={value !== tab} id={`proposal-edit-tabpanel-${tab}`} aria-labelledby={`proposal-edit-tab-${tab}`}>
			{value === tab && <Box sx={{ py: 0 }}>{children}</Box>}
		</div>
	);
};
